import { isAuthenticatedSession, SessionStatus } from './sessionState';

export enum UserConfigurationStatus {
    IDLE = 'idle',
    LOADING = 'loading',
    READY = 'ready',
    FAILED = 'failed',
}

export const canRenderProtectedApp = (
    sessionStatus: SessionStatus,
    configurationStatus: UserConfigurationStatus,
): boolean =>
    isAuthenticatedSession(sessionStatus) && configurationStatus === UserConfigurationStatus.READY;
